import React, { useState } from "react";
import FollowupClientSelector from "./FollowupClientSelector";
import FollowupTable from "./FollowupTable";
import { useNavigate } from "react-router-dom";
import { getFeedbackClients } from "utils/followUpService";
import { useQuery } from "@tanstack/react-query";
import useKothar from "context/useKothar";
import { hasPermission } from "utils/permissionUtils";
import { P } from "const/permissions";

const FollowUp = () => {
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const navigate = useNavigate();
  const [{ userDetail }, {}] = useKothar();
  const handleClientAdded = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleRowClick = (clientId, followUpId) => {
    setSelectedClientId(clientId);
    navigate(`/admin/follow-up/view/${clientId}/${followUpId}`);
  };

  const {
    data: feedbackClients,
    isLoading: isFeedbackClientsLoading,
    error: feedbackClientsError,
    refetch,
  } = useQuery({
    queryKey: ["feedbackClientsTable", refreshTrigger],
    queryFn: getFeedbackClients,
  });

  const hasPermissionToFollowUpAdmin =
    userDetail?.type === "SUPER_ADMIN" || hasPermission(P.FOLLOWUP.ADMIN);

  return (
    <div className="min-h-screen bg-app-surface-muted/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 lg:py-8">
        {hasPermissionToFollowUpAdmin && (
          <>
            {/* Page header */}
            <header className="mb-8">
              <h1 className="text-2xl font-semibold text-app-text tracking-tight">
                Follow Up Management
              </h1>
              <p className="mt-1 text-sm text-app-text-muted">
                Manage clients in the feedback queue and track discussions.
              </p>
            </header>

            {/* Add clients card */}
            <section className="mb-8">
              <div className="bg-app-surface rounded-xl border border-app-border/80 shadow-sm overflow-hidden">
                <div className="p-6">
                  <FollowupClientSelector
                    onClientAdded={handleClientAdded}
                    selectedClients={selectedClients}
                    setSelectedClients={setSelectedClients}
                    feedbackClients={feedbackClients}
                    isFeedbackClientsLoading={isFeedbackClientsLoading}
                  />
                </div>
              </div>
            </section>
          </>
        )}

        {/* Clients table */}
        <section>
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-semibold text-app-text">Clients for follow up calls</h2>
          </div>
          <FollowupTable
            refreshTrigger={refreshTrigger}
            onRowClick={handleRowClick}
            selectedClients={selectedClients}
            feedbackClients={feedbackClients}
            isFeedbackClientsLoading={isFeedbackClientsLoading}
            feedbackClientsError={feedbackClientsError}
            hasPermissionToFollowUpAdmin={hasPermissionToFollowUpAdmin}
          />
        </section>
      </div>
    </div>
  );
};

export default FollowUp;
